import { dehydrate, QueryClient, useQuery, UseQueryOptions } from 'react-query'
import { ApiClient } from 'services/ApiClient'
import { Api } from 'types/Api'
import { ProductDetail } from 'models/Product'
import { OrderType } from 'models/Order'

export namespace FetchProductDetail {
  export type Response = ProductDetail
  export type Error = Api.Error
  export type Options = UseQueryOptions<Response, Error>
}

const createKey = (productId: string) => ['product', productId]

const queryFetcher = (productId: string) => () => {
  return ApiClient.post<FetchProductDetail.Response>(`/v1/products/${productId}/preview`, {
    data: { orderType: OrderType.PRODUCTS_SUBSCRIPTION },
  })
}

export const useFetchProductDetail = (productId: string, options?: FetchProductDetail.Options) => {
  return useQuery<FetchProductDetail.Response, FetchProductDetail.Error>(
    createKey(productId),
    queryFetcher(productId),
    options
  )
}

export const prefetchProductDetail = async (
  productId: string,
  options?: FetchProductDetail.Options
) => {
  const queryClient = new QueryClient()

  await queryClient.prefetchQuery<FetchProductDetail.Response, FetchProductDetail.Error>(
    createKey(productId),
    queryFetcher(productId),
    options
  )

  return {
    dehydratedState: dehydrate(queryClient),
    data: queryClient.getQueryData(['product', productId]) as FetchProductDetail.Response,
  } 
}
